import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MobileToasterService {

  MobileToaster$ = new BehaviorSubject<Toaster>({} as Toaster);
}

interface Toaster {
  severity: string,
  summary: string,
  detail: string,
  appear?: boolean,
  bar?: boolean
}